import React from "react";

const Footer = () => {
  return (
    <div
      id="contacts"
      className="flex justify-evenly items-center bg-[#212428] text-[#c4cfde] w-full py-4 flex-col lgl:flex-row"
    >
      <p>Pranav Vishal</p>
      <p>Ontario, Canada</p>
      <p>+1 (519) 807-9596</p>
      <p>pvishal@uwaterloo.ca</p>
    </div>
  );
};

export default Footer;
